'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
  var account = _ref.account;
  var environment = _ref.environment;

  var scriptTag = '<script src="https://assets.adobedtm.com/' + account + environment + '.js"></script>';

  var track = function track(eventName, state) {
    if (typeof window === 'undefined') {
      return;
    }

    if (typeof eventName === 'undefined') {
      throw new Error('DTM adapter: when calling track() eventName property not defined');
    }

    if (typeof state === 'undefined') {
      throw new Error('DTM adapter: when calling track(), state property not defined');
    }

    window.analytics = _extends({}, state);

    if (window.ANALYTICS_DEBUG) {
      console.log({ adapter: 'dtm', type: 'track', eventName: eventName, state: state }); // eslint-disable-line no-console
    }

    var _window = window;
    var satellite = _window._satellite;


    if (typeof satellite !== 'undefined' && typeof satellite.track === 'function') {
      var sCode = window.s;

      if (typeof sCode !== 'undefined' && typeof sCode.clearValues === 'function') {
        sCode.clearValues();
      }

      satellite.track(eventName);
    }
  };

  return {
    track: track,
    scriptTag: scriptTag
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/adapters/dtm/index.js
 ** module id = 406
 ** module chunks = 0
 **/